import baseAPI from '@/http'

const router = 'api/arquivo/excel'

export const referenceTermAPI = {
  upload: (file) => baseAPI.post(`${router}/upload-tr`, file)
}
